var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpvoteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140737",
    fill: "none",
    d: "M0 0h19v19H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48198",
    d: "m9.5 3.642 5.344 6.008h-3.8v5.926H7.956V9.65h-3.8L9.5 3.642m0-2.058a.853.853 0 0 0-.594.247L1.821 9.856a.845.845 0 0 0-.212.924.791.791 0 0 0 .766.517h4v5.1a.808.808 0 0 0 .792.823h4.664a.808.808 0 0 0 .8-.821v-5.1h4a.791.791 0 0 0 .766-.517.845.845 0 0 0-.212-.924l-7.092-8.027a.853.853 0 0 0-.593-.247Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvoteWhite);
export default __webpack_public_path__ + "static/media/upvote_white.a7b2f294cb4d23efd7c14d4e6ce3d4ac.svg";
export { ForwardRef as ReactComponent };